/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getNextBestAction} from '../api'

 export const useQueryGetNextBestAction = createReactQueryHook('getNextBestAction', getNextBestAction)
